export default {
  sms: 'SMS',
  googleAuth: 'TOTP'
};